/**
 * @file authConfig.js
 * @description Authentication configuration for the application.
 * @component AuthConfig
 * @exports AuthConfig - Main component for authentication configuration.
 */

export const APP_LG_CLIENTID = process.env.REACT_APP_LG_CLIENTID;
export const APP_LG_AUTHORITY = process.env.REACT_APP_LG_AUTHORITY;
export const APP_LG_REDIRECTURL = process.env.REACT_APP_LG_REDIRECTURL;
export const APP_LG_SCOPE = process.env.REACT_APP_LG_SCOPE;

export const msalConfig = {
    auth: {
      clientId: APP_LG_CLIENTID, // from Azure portal
      authority: APP_LG_AUTHORITY,
      //redirectUri: APP_LG_REDIRECTURL,
      redirectUri: window.location.origin,
    },
    cache: {
      cacheLocation: "localStorage", // or "sessionStorage"
      storeAuthStateInCookie: false,
    },
  };
  
  export const loginRequest = {
    scopes: [APP_LG_SCOPE],
  };


